import React, { useState } from 'react';
import styled from 'styled-components';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

import Section from '../global/section';
import Top from '../top';

const StyledFacts = styled.div`
	section {
		text-align: center;
		.circle-container {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 3rem;
			.circle {
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				padding: 0 2rem;

				.counter {
					background-color: ${(p) => p.theme.color.red};
					height: 7rem;
					width: 7rem;
					border-radius: 50%;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-bottom: 1rem;
					padding: 7px;
					border: 2px solid ${(p) => p.theme.color.red};
					background-clip: content-box;

					span {
						font-family: ${(p) => p.theme.fonts.heading};
						color: #fff;
						font-size: 2rem;
						font-weight: 600;
						line-height: 2rem;
					}
				}

				&:last-child .counter span {
					font-size: 1.3rem;
				}

				p {
					font-weight: 700;
				}
			}

			@media all and (max-width: 825px) {
				.circle {
					padding: 0 1.5rem;
				}
			}
			@media all and (max-width: 768px) {
				flex-wrap: wrap;
				width: 80%;
				margin: 0 auto;

				.circle {
					width: 33.3%;
					margin-top: 2rem;
				}
			}
			@media all and (max-width: 650px) {
				.circle {
					width: 50%;
				}
			}
			@media all and (max-width: 450px) {
				width: 100%;
			}
		}
	}
`;

export default ({ data }) => {
	const { top, title, circles } = data;

	// Countup component visibility checker
	const [viewedCountup, setViewedCountup] = useState(false);
	const onVisibilityChange = (isVisible) => {
		if (isVisible) {
			setViewedCountup(true);
		}
	};

	return (
		<StyledFacts>
			<Section bg="light">
				<Top color="red">{top}</Top>
				<h2>{title}</h2>
				<div className="circle-container">
					{circles.map((x, i) => (
						<div className="circle" key={i}>
							<div className="counter">
								<VisibilitySensor onChange={onVisibilityChange} delayedCall>
									<CountUp
										duration={2}
										separator=","
										end={viewedCountup ? parseInt(x.number) : 0}
									/>
								</VisibilitySensor>
							</div>
							<p>{x.text}</p>
							<p>{x.text2}</p>
						</div>
					))}
				</div>
			</Section>
		</StyledFacts>
	);
};
